<app-model-field-select-button
  [id]="id()"
  [label]="label()"
  [tooltipKey]="tooltipKey()"
  [options]="options()"
  [(value)]="value"
  [isReadOnly]="isReadOnly()"
  [allowEmpty]="false"
  styleClass="btn-select-toggle-grey"
/>
